<template>
  <v-card class="pa-1">
    <v-container>

      <!-- <Select
        icon="mdi-calendar-clock"
        itemText="tipo"
        itemValue="token"
        v-model="value.practica"
        :items="lista_practicas"
        label="Elige una Práctica"
        rules="required"
        name="La practica"
      /> -->

      <p class="mb-1">Por favor, elige el tipo de solicitud que deseas realizar: </p>

      <Select
        icon="mdi-calendar-clock"
        itemText="nombre"
        itemValue="id"
        v-model="value.tipo_solicitud"
        :items="tipos_solicitud"
        label="Tipo de solicitud"
        rules="required"
        name="El tipo de solicitud"
      />

      <v-sheet v-if="value.tipo_solicitud == 1">
        <v-container>
          <v-row class="mb-3">Ingresa los datos de tu nuevo supervisor</v-row>

          <TextField
            name="El nombre del supervisor"
            rules="required"
            label="Nombre"
            v-model="value.supervisor.nombre"
            icon="mdi-form-textbox"
          ></TextField>

          <TextField
            name="El apellido del supervisor"
            rules="required"
            label="Apellido"
            v-model="value.supervisor.apellido"
            icon="mdi-form-textbox"
          ></TextField>

          <TextField
            name="El e-mail del supervisor"
            rules="required|email"
            label="E-mail"
            v-model="value.supervisor.email"
            icon="mdi-form-textbox"
          ></TextField>

          <TextField
            name="El telefono del supervisor"
            rules="required|max:18|telefono"
            label="Telefono"
            counter="18"
            v-model="value.supervisor.telefono"
            icon="mdi-form-textbox"
          ></TextField>
          
        </v-container>
      </v-sheet>
      <v-sheet v-if="value.tipo_solicitud == 2">
        <v-container>
          <v-row class="mb-3">Ingresa la nueva fecha de inicio</v-row>
          <DatePicker
        v-model="value.fecha_inicio"
        label="Fecha de inicio"
        name="La fecha de inicio"
        rules="required"
      />

        </v-container>
      </v-sheet>
      <v-sheet v-if="value.tipo_solicitud == 3">
        <v-container>
          <v-row class="mb-3">Ingresa el nuevo modo de práctica</v-row>
          <ValidationProvider
            v-slot="{ errors }"
            name="El modo de la práctica"
            rules="required"
          >
            <v-select
              :items="modos_local"
              rounded
              :error-messages="errors"
              v-model="value.modo"
              prepend-inner-icon="mdi-calendar-clock"
              item-value="id"
              item-text="nombre"
              filled
              label="Modo de Práctica"
            ></v-select>
          </ValidationProvider>
        </v-container>
      </v-sheet>

      <v-sheet v-if="value.tipo_solicitud == 4"
        >Se reenviará el mail de confirmación de tu práctica a tu
        supervisor
      </v-sheet>

      <v-sheet v-if="value.tipo_solicitud == 5"
        >Se reenviará el mail de evaluación de tu práctica a tu
        supervisor
      </v-sheet>

      <v-sheet>
        <v-container>
          <v-row class="mb-3">Ingresa el motivo del cambio</v-row>
          <ValidationProvider
            v-slot="{ errors }"
            name="El motivo del cambio"
            rules="required"
          >
            <v-textarea
              rounded
              :error-messages="errors"
              v-model="value.mensaje"
              no-resize
              filled
              label="Motivo"
            ></v-textarea>
          </ValidationProvider>
        </v-container>
      </v-sheet>
    </v-container>
  </v-card>
</template>

<script>

import DatePicker from '@/components/forms/DatePicker.vue'
import {ValidationProvider} from "vee-validate";
import Select from "@/components/forms/Select.vue";
import TextField from "@/components/forms/TextField.vue";
import {
  NOMBRE_CARRERA_CIVIL,
  NOMBRE_CARRERA_EJECUCION,
  REGLA_CIVIL,
  REGLA_EJECUCION,
  TIPO_INDUSTRIAL,
  TIPO_PROFESIONAL,
  modosDisponibles,
} from "@/helpers/modos";


export default {
  components: {
    ValidationProvider,
    Select,
    TextField,
    DatePicker
  },
  props:['value', 'practica_token'],
  computed: {
    modos() {
      // Mientras la petición de modos no responde, el store no tiene `items`.
      return this.$store.state.tables.modos_practica.items || [];
    },
    tipos_solicitud() {
      return this.$store.state.tables.tipos_solicitud.items;
    },
    
    // lista_practicas() {
    //   return this.$store.state.tables.lista_practicas.items;
    // },
    practicas() {
      return this.$store.state.tables.practicas.items;
    },

    // Los modos a los que el alumno puede cambiar la práctica elegida: depende
    // de su tipo, de la carrera y, en la profesional de Civil, del modo de la
    // industrial (ver helpers/modos.js). El modo que la práctica ya tiene no se
    // ofrece; la práctica trae el nombre del modo, que es único.
    modos_local() {
      const { industrial, profesional } = this.practicas || {};
      let tipo = null;
      let practica = null;
      if (industrial && industrial.token === this.practica_token) {
        tipo = TIPO_INDUSTRIAL;
        practica = industrial;
      } else if (profesional && profesional.token === this.practica_token) {
        tipo = TIPO_PROFESIONAL;
        practica = profesional;
      }
      // La carrera se reconoce por su nombre exacto; si no es ninguna de las
      // dos, la profesional no tiene reglas de carrera.
      let regla = null;
      if (practica && practica.carrera == NOMBRE_CARRERA_EJECUCION) {
        regla = REGLA_EJECUCION;
      } else if (practica && practica.carrera == NOMBRE_CARRERA_CIVIL) {
        regla = REGLA_CIVIL;
      }
      const disponibles = modosDisponibles(this.modos, {
        tipo,
        regla,
        nivelDeDuracionIndustrial: industrial ? industrial.nivel_de_duracion_modo : null,
      });
      return practica
        ? disponibles.filter((modo) => modo.nombre !== practica.modo)
        : disponibles;
    },
  },

  created() {
    this.$store.dispatch("tables/get", { endpoint: 'practica/modos', table: "modos_practica" });
    // this.$store.dispatch("tables/get", { endpoint: 'solicitudes/practicas', table: "lista_practicas" });
    this.$store.dispatch("tables/get", { endpoint: 'solicitudes/tipos', table: "tipos_solicitud" });

    this.value.practica = this.practica_token
  },
};
</script>

<style></style>
